import { Title, Button, Text, Badge } from "@mantine/core";
import { IconArrowLeft, IconBoxSeam, IconAlertTriangle, IconTruckDelivery, IconShoppingCart } from "@tabler/icons";
import image from "../public/inventory2_trim.webp";
import { MediaStage } from "./MediaStage";
import classes from "../styles/InventorySection.module.css";

export function InventorySection() {
    const features = [
        { text: "התראות מלאי נמוך ישירות לוואטסאפ", icon: <IconAlertTriangle size={24} /> },
        { text: "חידוש סחורה בקליק מול הספקים", icon: <IconTruckDelivery size={24} /> },
        { text: "סנכרון מלא עם הכרטיס הדיגיטלי", icon: <IconShoppingCart size={24} /> },
        { text: "יומן מלאי שקוף ומדויק בזמן אמת", icon: <IconBoxSeam size={24} /> },
    ];

    return (
        <div className={classes.wrapper}>
            <div className={classes.image}>
                <MediaStage
                    image={image}
                    variant="screen"
                    callouts={["התראת מלאי נמוך בוואטסאפ"]}
                    sizes="(max-width: 800px) 92vw, 560px"
                    alt="מסך ניהול המלאי של QuickTor: רשימת מוצרים עם כמות, מחירי קנייה ומכירה, וסטטוס קרוב להתרוקנות"
                />
            </div>

            <div className={classes.body}>
                <Badge
                    size="lg"
                    variant="light"
                    color="orange"
                    className={classes.badge}
                >
                    ניהול חנות ומלאי
                </Badge>

                <Title order={2} className={classes.title}>
                    המלאי שלך מנוהל מעצמו
                </Title>
                <Text className={classes.subtitle}>
                    לא צריך יותר לנחש מה נגמר במדף.
                    המערכת תדע להתריע כשיש חוסר, תאפשר רכישה דרך הכרטיס הדיגיטלי, ותדאג שהמדפים (והקופה) תמיד יהיו מלאים.
                </Text>

                <div className={classes.featuresGrid}>
                    {features.map((feature, index) => (
                        <div key={index} className={classes.featureCard}>
                            <div className={classes.iconContainer}>{feature.icon}</div>
                            <Text className={classes.featureText}>{feature.text}</Text>
                        </div>
                    ))}
                </div>

                <Button
                    className={classes.ctaButton}
                    rightSection={<IconArrowLeft size={18} />}
                    component="a"
                    href={"https://app.quicktor.co.il"}
                >
                    אני רוצה לנסות בחינם &gt;&gt;
                </Button>
            </div>
        </div>
    );
}
